module.exports = __webpack_public_path__ + "static/media/home-contracting-2@2x.e8c3029b.jpg";